module.exports = __webpack_public_path__ + "fe2693dfc4c36d83b016daa3286e665e.png";